<template>
    <div class="hstack">
        <ExperiencePositionTimeline :position="position" />
        <div class="container-03">
            <h4>{{ position.name }}</h4>
            <ul class="list-simple">
                <li v-for="item in position.responsibilities" :key="item" class="caption">
                    {{ item }}
                </li>
            </ul>
            <ul class="software">
                <li v-for="item in position.software" :key="item.hash">
                    <ExperiencePositionSoftware :software="item" />
                </li>
            </ul>
        </div>
    </div>
</template>

<script lang="ts">
import { ResumeExperiencePosition } from '@/models/Resume'
import ExperiencePositionSoftware from './ExperiencePositionSoftware.vue'
import ExperiencePositionTimeline from './ExperiencePositionTimeline.vue'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    name: "experience-position",
    components: {
        ExperiencePositionSoftware,
        ExperiencePositionTimeline
    },
    props: {
        position: {
            type: Object as PropType<ResumeExperiencePosition>,
            required: true
        } 
    }
})

</script>

<style lang="stylus" scoped>

@import "~../../src/styles/styles";

.software {
    display: flex
    flex-direction column
    gap: 11pt    
    margin-top: 12pt
}

.hstack {
    display: flex    
    gap: 10pt
}

</style>